'use client';
import { X } from 'lucide-react';
import { useRouter, useSearchParams } from 'next/navigation';

import { Dialog, DialogClose, DialogContent } from '@/components/ui/dialog';
import PlanDetailsPage from '@/freight/components/PlanDetailsPage';

export default function PlanDetailsModal({ resultId, planId }: { resultId: string; planId: string }) {
    const router = useRouter();
    const searchParams = useSearchParams();
    const initialCurrency = searchParams.get('currency');
    const quote = searchParams.get('quote') === '1';

    return (
        <Dialog
            open
            onOpenChange={(open) => {
                if (!open) {
                    router.back();
                }
            }}
        >
            <DialogContent className="p-0 rounded-lg" noClose fullScreen>
                <PlanDetailsPage
                    resultId={resultId}
                    planId={planId}
                    initialCurrency={initialCurrency ?? undefined}
                    backToQuotePage={quote}
                />

                <DialogClose className="absolute -right-4 -top-4 rounded-full p-2 bg-frGrey-990 text-white ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
                    <X className="h-4 w-4" />
                    <span className="sr-only">Close</span>
                </DialogClose>
            </DialogContent>
        </Dialog>
    );
}
